import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "zdroj",
  kodKey: "nazev",
  placeholderText: "VZO"
});
